module.exports = __webpack_public_path__ + "static/media/food-chooser-image.0b2f02b8.svg";